import { render, staticRenderFns } from "./sightsPic.vue?vue&type=template&id=0b81f960&scoped=true&"
import script from "./sightsPic.vue?vue&type=script&lang=js&"
export * from "./sightsPic.vue?vue&type=script&lang=js&"
import style0 from "./sightsPic.vue?vue&type=style&index=0&id=0b81f960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b81f960",
  null
  
)

export default component.exports